<template lang="pug">
md-input-container
  label(for='household') Household
  md-select#household(name='household', :multiple='multiple', v-model='selected', @selected='onSelected')
    md-option(v-for='household in households', :value='household.key' :key="household.key") {{ household.value }}
</template>

<script>
  import { metrics } from '../../assets/data/demographics';

  export default {
    props: {
      value: {
        type: [String, Array],
        required: true
      },
      multiple: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selected: this.value,
        households: metrics.composition
      };
    },
    methods: {
      onSelected(value) {
        this.$emit('input', value);
      }
    },
    watch: {
      value(newValue) {
        if (newValue) {
          this.selected = newValue;
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/shared-components/demographic/HouseHoldSelector.vue